import { CommonModule } from '@angular/common';
import {
  Component,
  contentChild,
  input,
  output,
  TemplateRef,
} from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

export interface Item {
  title: string;
  formGroup: FormGroup;
}

@Component({
  selector: 'app-form-array-card',
  imports: [CommonModule, TranslatePipe],
  templateUrl: './form-array-card.component.html',
  styleUrl: './form-array-card.component.scss',
})
export class FormArrayCardComponent {
  formArray = input.required<FormArray<FormGroup>>();
  title = input.required<string>();
  itemTemplate =
    contentChild.required<TemplateRef<{ $implicit: FormGroup }>>(TemplateRef);
  addButtonTitle = input.required<string>();
  disabled = input<boolean>(false);

  add = output<void>();
  remove = output<number>();
}
